import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var salaryListRes;
export const salaryListTodo = createAsyncThunk('salaryList', async (data) => {
    let user_id = JSON.parse(localStorage.getItem('user_data'))
    try {
        const res = await axios({

            method: "post",
            url: process.env.REACT_APP_API_URL + 'hr/view_pay_slip',
            data: {
                "user_id": user_id.vemp_code,
                "user_role": user_id.vrole_name,
                "device_token": user_id.vdevice_token,
                "ibusiness_area_id": user_id.ibusiness_area_id,
                "vemp_type": user_id.cemp_type,
                "vfin_year_name": data.year
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + user_id.access_token }
        })
        return salaryListRes = res.data
    } catch (error) {
        return salaryListRes = error.response.data
    }
})


const salaryListSlice = createSlice({
    name: 'salaryList',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(salaryListTodo.fulfilled, (state, action) => {
            if (action.payload.success) {
                state.data = action.payload;
                // console.log('salaryList', state.data)
            }
        });
        builder.addCase(salaryListTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default salaryListSlice.reducer; 